import axios, { AxiosInstance }  from 'axios';
import createdStore from '../store/store';
import { getCookie } from './persistence';

function getHeaders(proxyKey?: string, instanceHeaders?: any) {
  const token = getCookie('token') || createdStore.store.getState().checkout.token;
  const acceptHeader = 'application/json, text/plain, */*;';
  return {
    Accept: acceptHeader,
    ...token && { 'api-token': token },
    ...((proxyKey || (instanceHeaders && instanceHeaders['x-functions-key'])) && { 'x-functions-key': proxyKey || instanceHeaders['x-functions-key'] }),
    'x-functions-key': 'oIP2A2icBq/UrL06DJkw2sn0ILxyJwgL6PxYEWMqNWsw3kzBPR4RYA==',
  };
}

let instance: AxiosInstance;

/**
 * Create a new instance of axios with the provided config
 * @param baseURL, client API endpoint
 * @param proxyKey, key for clients who use proxy reequests
 */
export function createRestInstance(baseURL: string, proxyKey?: string): any {
  instance = axios.create({ baseURL, withCredentials: false, headers: getHeaders(proxyKey) });
}

export const rest = {
  httpGet: (url: string) => instance.get(url, {
    headers: getHeaders(undefined, instance.defaults.headers),
  }),
  httpPost: (url: string, data?: object) => instance({
    method: 'post',
    url,
    data,
    headers: getHeaders(undefined, instance.defaults.headers),
  }),
  httpPut: (url: string, data?: object) => instance({
    method: 'put',
    url,
    data,
    headers: getHeaders(undefined, instance.defaults.headers),
  }),
  httpDelete: (url: string, data?: object) => instance({
    method: 'delete',
    url,
    data,
    headers: getHeaders(undefined, instance.defaults.headers),
  }),
};

/* eslint no-plusplus: ["error", { "allowForLoopAfterthoughts": true }] */
/**
 * Returns an object with query paramteters as keys and values
 * @param queryString
 */
export function getQueryParametersAsObject(queryString: string): any {
  if (!queryString || queryString.length <= 1) {
    return {};
  }

  let qs: any = queryString.substr(1);
  qs = qs.split(/&|#/);
  const obj = {};
  for (let i = 0; i < qs.length; i++) {
    qs[i] = qs[i].split('=');
    obj[qs[i].shift()] = decodeURIComponent(qs[i].join('='));
  }
  return obj;
}
